import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import NotePopUp from "./note_popup.js";
import HistoryPopUp from "./history_popup.js";
import AddDate from "./add_date.js";
import AddClientConn from "./addClientConn.js";
import "../styles/date_popup.css";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import ClientPopUp from "./client_popup.js";
import AdditionalWezw from "./additionalWezw.js";
import Select from "react-select";
import { faL } from "@fortawesome/free-solid-svg-icons";
import emailjs from "@emailjs/browser";

const MySwal = withReactContent(Swal2);

const DatePopUp = (props) => {
  const [hearingData, setHearingData] = useState("");
  const [fillHearing, setFillHearing] = useState(false);
  const [fillResult, setFillResult] = useState(false);
  const [fillNote, setFillNote] = useState(false);
  const [lawyer, setLawyer] = useState("");
  const [lawyer_form, setLawyerForm] = useState("");
  const [substitute_name, setSubstituteName] = useState("");
  const [guardian_name, setGuardianName] = useState("");
  const [result, setResult] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [subject, setSubject] = useState("");
  const [result_note, setResultNote] = useState("");
  const [note, setNote] = useState("");
  const [notePopUp, setNotePopUp] = useState(false);
  const [noteType, setNoteType] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [result_type, setResultType] = useState("");
  const [taskDate, setTaskDate] = useState("");
  const [taskTime, setTaskTime] = useState("");
  const [deliveryWn, setDeliveryWn] = useState("");
  const [responsible, setResponsible] = useState("");
  const [taskType, setTaskType] = useState([]);
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState([]);
  const [resultSub, setResultSub] = useState([]);
  const [resultSubIndex, setResultSubIndex] = useState([]);
  const [showAddClientConn, setShowAddClientConn] = useState(false);
  const [showClientReport, setShowClientReport] = useState(false);
  const [clientsReportValue, setClientsReportValue] = useState(false);
  const [clients, setClients] = useState([]);
  const [showAdditionalWezw, setShowAdditionalWezw] = useState(false);
  const [substitutesOptions, setSubstitutesOptions] = useState([]);
  const [taskTypesOptions, setTaskTypesOptions] = useState([]);
  const [lawyersOptions, setLawyersOptions] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [subUserId, setSubUserId] = useState("");
  const [hearings, setHearings] = useState([]);
  const [weekArray, setWeekArray] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [substitutes, setSubstitutes] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [results, setResults] = useState([]);
  const [expectedResults, setExpectedResults] = useState([]);

  const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
  };

  const getInitials = (user) => {
    var newData = props.usersData.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;

    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else if (new Date(y, 0, d).getFullYear() === 2024) {
      return new Date(y, 0, d);
    } else if (y === 2025) {
      return subDays(new Date(y, 0, d), 2);
    } else {
      return new Date(y, 0, d);
    }
  };

  const getDateOfWeek1 = (w, y) => {
    var d = 1 + (w - 1) * 7;

    return new Date(y, 0, d + 5);
  };

  const createWeekSet = async (data) => {
    var date = data.date;

    var startYear = new Date(date).getFullYear();
    var startDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));

    var weekNumber = Math.ceil(days / 7);

    var weekStartDate = getDateOfWeek(
      new Date(date).getDay() === 1 ? weekNumber + 1 : weekNumber,
      startYear
    );
    if (startDate.getMonth() === 0 && startDate.getFullYear() === 2025) {
      weekStartDate = getDateOfWeek1(weekNumber, startYear);
    } else {
      weekStartDate = getDateOfWeek(weekNumber, startYear);
    }

    var weekEndDate = addDays(weekStartDate, 6);

    var weekArrayB = [];

    for (var i = 0; i <= 6; ++i) {
      var actualDate = addDays(weekStartDate, i);

      weekArrayB.push(
        `${actualDate.getFullYear()}-${
          actualDate.getMonth() < 10
            ? "0" + (actualDate.getMonth() + 1)
            : actualDate.getMonth() + 1
        }-${
          actualDate.getDate() < 10
            ? "0" + actualDate.getDate()
            : actualDate.getDate()
        }`
      );
    }

    setWeekArray(weekArrayB);

    var body = {
      dateFrom: weekStartDate,
      dateTo: weekEndDate,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearings(data);
      })
      .catch((error) => {});
  };

  const setFill = (e) => {
    switch (e.target.value) {
      case "fillHearing": {
        setFillHearing(true);
        setFillNote(false);
        setFillResult(false);
        break;
      }
      case "fillResult": {
        setFillResult(true);
        setFillNote(false);
        setFillHearing(false);
        break;
      }
      case "fillNote": {
        setFillNote(true);
        setFillResult(false);
        setFillHearing(false);
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleLawyerChange = (e) => {
    setLawyer(e.target.value);
  };

  const handleTaskTypeChange = (e) => {
    setTaskType(e.value);
  };

  const handleResultNoteChange = (e) => {
    setResultNote(e.target.value);
  };

  const handleLawyerFormChange = (e) => {
    setLawyerForm(e.target.value);
  };

  const handleTaskDateChange = (e) => {
    setTaskDate(e.target.value);
  };

  const handleDeliveryWnChange = (e) => {
    setDeliveryWn(e.target.value);
  };

  const handleResponsibleChange = (e) => {
    setResponsible(e.value);
  };

  const handleSubstituteNameChange = (e) => {
    setSubstituteName(e.value);
  };

  const handleGuardianNameChange = (e) => {
    setGuardianName(e.value);
  };

  const handleResultChange = (e) => {
    setResult(e.target.value);
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
  };

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const handleResultTypeChange = (e) => {
    setResultType(e.target.value);
  };

  const acceptHearing = async () => {
    var body = {
      id: props.dateID,
    };

    await fetch("https://apidevkppp.ftpeople.pl/acceptDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Zaakceptowano",
      text: "termin rozprawy",
    }).then((result) => {
      props.close();
    });
  };

  const changeStausChecked = async () => {
    var body = {
      id: props.dateID,
    };

    await fetch("https://apidevkppp.ftpeople.pl/checkDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Sprawdzono",
      text: "termin rozprawy",
    }).then((result) => {
      props.close();
    });
  };

  const saveFillHearing = async () => {
    setLoading(true);
    var body = {
      id: props.dateID,
      lawyer: lawyer,
      lawyer_form: lawyer_form,
      substitute_name: substitute_name,
      guardian_name: guardian_name,
      clientId: hearingData.clientId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/fillLawyerDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
        var templateParams = {
          to:
            props.usersData.filter((el) => el.name === lawyer).length > 0
              ? props.usersData.filter((el) => el.name === lawyer)[0].mail
              : "",
          name: hearingData.name,
          date_date: hearingData.date + " " + hearingData.time,
          court: hearingData.court,
          sygn: hearingData.sygn,
          subject:
            "Została Ci przypisana rozprawa: " +
            hearingData.name +
            ", " +
            hearingData.date +
            " " +
            hearingData.time +
            " - przedmiot rozprawy: " +
            hearingData.subject,
          user_name: props.user.name,
        };

        emailjs.send("KPPP", "template_711ldto", templateParams).then(
          function (response) {
            MySwal.fire({
              icon: "success",
              title: "Uzupełniono",
              text: "dane prawnika",
            }).then((result) => {
              props.close();
            });
          },
          function (error) {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "nie wysłano wiadomości e-mail. Ponów operację!",
            }).then(async (result) => {
              props.close();
            });
          }
        );
      })
      .catch((error) => {});
  };

  const addHearingData = (e) => {
    if (!checkHoliday(lawyer, hearingData.date)) {
      if (validateFillHearing()) {
        saveFillHearing();
        addNewTask3();
        addNewTask3a();
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else {
      MySwal.fire({
        title:
          "Osoba, której chcesz przypisać rozprawę jest w tym czasie na urlopie. Czy nadal chcesz jej przypisać rozprawę?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (validateFillHearing()) {
            saveFillHearing();
            addNewTask3();
            addNewTask3a();
          } else {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "Wypełnij wymagane pola formularza",
            });
          }
        } else if (result.isDenied) {
          setLoading(false);
        }
      });
    }
  };

  const numberWithCommas = (data) => {
    return data.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const addNewHearing = async () => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();

    var body = {
      name: hearingData.name,
      date: date,
      time: time,
      court: hearingData.court,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      wps: hearingData.wps,
      form: hearingData.form,
      online_url: hearingData.url,
      subject: subject,
      date_added: date_added,
      user_added: props.user.name,
      lawyer: hearingData.lawyer,
      lawyer_form: hearingData.lawyer_form,
      substitute_name: hearingData.substitute_name,
      guardian_name: hearingData.guardian_name,
      note: "",
      accepted: "no",
      status: "DO SPRAWDZENIA",
      readed: "no",
      clientId: hearingData.clientId,
      team: hearingData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertFullDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const addNewTask = async (task, lawyer) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var date_final = new Date(taskDate);

    var lawEmp = hearingData.lawyer;
    var type = "Apelacyjna";
    if (
      hearingData.court.toLowerCase().includes("apel") ||
      hearingData.subject === "Apelacyjna"
    ) {
      type = "Apelacyjna";
    } else {
      type = "Normalna";
    }

    var index =
      resultSubIndex.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === type && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === type && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === type && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    while (
      checkFree(date_final) ||
      //checkHoliday(
      //  props.user.role === "admin" ? responsible : lawEmp,
      //  date_final
      //) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    var date_final_1 =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body = {
      responsible: checkSubstitute()
        ? lawEmp
        : props.user.role === "admin"
        ? responsible
        : lawEmp,
      start_date: date_start,
      final_date: date_final_1,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      client_name: hearingData.name,
      task: task,
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "SĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: type,
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});
  };

  const addNewTaskDate = async (taskC) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var date_final =
      addDayFiveMonths(new Date()).getFullYear() +
      "-" +
      addDayFiveMonths(new Date()).getMonth() +
      "-" +
      addDayFiveMonths(new Date()).getDate();

    var lawEmp = hearingData.lawyer;
    var type = "Apelacyjna";
    if (
      hearingData.court.toLowerCase().includes("apel") ||
      hearingData.subject === "Apelacyjna"
    ) {
      type = "Apelacyjna";
    } else {
      type = "Normalna";
    }

    var index =
      resultSubIndex.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === type && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === type && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === type && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    while (
      checkFree(date_final) ||
      //checkHoliday(
      //  props.user.role === "admin" ? responsible : lawEmp,
      //  date_final
      //) ||
      new Date(date_final).getDay() === 0 ||
      new Date(date_final).getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    var body = {
      responsible: checkSubstitute()
        ? lawEmp
        : props.user.role === "admin"
        ? responsible
        : lawEmp,
      start_date: date_start,
      final_date: date_final,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      client_name: hearingData.name,
      task: taskC,
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "SĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: type,
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});
  };

  const addNewTaskForm = async () => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var date_final =
      new Date(taskDate).getFullYear() +
      "-" +
      (new Date(taskDate).getMonth() + 1) +
      "-" +
      new Date(taskDate).getDate();

    var lawEmp = hearingData.lawyer;
    var type = "Apelacyjna";
    if (
      hearingData.court.toLowerCase().includes("apel") ||
      hearingData.subject === "Apelacyjna"
    ) {
      type = "Apelacyjna";
    } else {
      type = "Normalna";
    }

    var index =
      resultSubIndex.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === type && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === type && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === type && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    while (
      checkFree(date_final) ||
      //checkHoliday(
      //  props.user.role === "admin" ? responsible : lawEmp,
      //  date_final
      //) ||
      new Date(date_final).getDay() === 0 ||
      new Date(date_final).getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    var body = {
      responsible: checkSubstitute()
        ? lawEmp
        : props.user.role === "admin"
        ? responsible
        : lawEmp,
      start_date: date_start,
      final_date: date_final,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      client_name: hearingData.name,
      task: taskType,
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "SĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: type,
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const addDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 30));
    return retDate;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addDayTwo = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 2));
    return retDate;
  };

  const addDayThre = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 3));
    return retDate;
  };

  const addDayThreeMonths = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 90));
    return retDate;
  };

  const addDayTwoMonths = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 60));
    return retDate;
  };

  const addDayFiveMonths = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 150));
    return retDate;
  };

  const addDayWeek = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 7));
    return retDate;
  };

  const subDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 30));
    return retDate;
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const addDayFive = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 5));
    return retDate;
  };

  const addDayFourteen = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 14));
    return retDate;
  };

  const addNewTask3 = async () => {
    var identifier = new Date().valueOf() + 1 + Math.random();
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var dateFinal = addDayFourteen(new Date(hearingData.date));

    var date_final = dateFinal;

    while (
      checkFree(date_final) ||
      checkHoliday(
        props.user.role === "admin" ? responsible : props.user.name,
        date_final
      ) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawyer,
      client_name: hearingData.name,
      task: "Sprawdź dokumenty przed rozprawą!",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const addNewTask3a = async () => {
    var identifier = new Date().valueOf() + 1 + Math.random();
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var dateFinal = addDayFive(new Date(hearingData.date));
    var date_final = dateFinal;

    while (
      checkFree(date_final) ||
      checkHoliday(
        props.user.role === "admin" ? responsible : props.user.name,
        date_final
      ) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawyer,
      client_name: hearingData.name,
      task: "Jeżeli w sprawie jest substytut lub działa się jako opiekun potwierdzić e-mailowo, że pełnomocnik substytucyjny ma wszystkie dokumenty i kontaktował się z klientem",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const addNewTask5 = async (rand) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();
    var newFinalDate = addDayThreeMonths(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    var lawEmp = hearingData.lawyer;
    var index =
      resultSubIndex.filter(
        (el) => el.type === "Normalna" && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === "Normalna" && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === "Normalna" && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === "Normalna" && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === "Normalna" && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === "Normalna" && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    while (
      checkFree(date_final) ||
      checkHoliday(lawEmp, date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var toAdd = [];

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Sprawdzić czy apelacja wpłynęła",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: "Normalna",
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});

    var date_added3 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start3 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal3 = new Date();
    var newFinalDate3 = addDayThre(new Date());
    if (newFinalDate3.getDay() === 0) {
      newFinalDate3 = new Date(
        newFinalDate3.setDate(newFinalDate3.getDate() + 1)
      );
    }
    if (newFinalDate3.getDay() === 6) {
      newFinalDate3 = new Date(
        newFinalDate3.setDate(newFinalDate3.getDate() + 2)
      );
    }

    var date_final = newFinalDate3;

    while (
      checkFree(dateFinal) ||
      checkHoliday(lawEmp, date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal3 =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body2 = {
      start_date: date_start3,
      final_date: dateFinal3,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Opłata początkowa – sprawdzić czy klient zapłacił wszystkie raty",
      date_added: date_added3,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body2),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    var date_added2 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start2 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var date_final = new Date(taskDate);

    while (
      checkFree(date_final) ||
      //checkHoliday(
      //  props.user.role === "admin" ? responsible : lawEmp,
      //  date_final
      //) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      new Date(date_final).getFullYear() +
      "-" +
      (new Date(date_final).getMonth() + 1) +
      "-" +
      new Date(date_final).getDate();

    var body3 = {
      responsible: checkSubstitute()
        ? lawEmp
        : props.user.role === "admin"
        ? responsible
        : lawEmp,
      start_date: date_start2,
      final_date: dateFinal,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      client_name: hearingData.name,
      task: "Wniosek o uzasadnienie",
      date_added: date_added2,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "SĄDOWE",
      reded: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    if (deliveryWn === "tak") {
      await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body3),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
    }
  };

  const addNewTask6 = async (rand) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();
    var newFinalDate = addDayTwoMonths(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    while (
      checkFree(date_final) ||
      checkHoliday("Mateusz Płudowski", date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var toAdd = [];

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: "Mateusz Płudowski",
      client_name: hearingData.name,
      task: "Sprawdzić czy KZP i SCF zapłacone",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    var date_added2 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start2 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal2 = new Date();
    var newFinalDate2 = addDayWeek(new Date());
    if (newFinalDate2.getDay() === 0) {
      newFinalDate2 = new Date(
        newFinalDate2.setDate(newFinalDate2.getDate() + 1)
      );
    }
    if (newFinalDate2.getDay() === 6) {
      newFinalDate2 = new Date(
        newFinalDate2.setDate(newFinalDate2.getDate() + 2)
      );
    }

    var date_final = newFinalDate2;
    var lawEmp = hearingData.lawyer;

    var index =
      resultSubIndex.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    while (
      checkFree(date_final) ||
      checkHoliday(lawEmp, date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal2 =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body2 = {
      start_date: date_start2,
      final_date: dateFinal2,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Wysłać wezwanie o KZP do pełnomocnika banku oraz rozliczenie SCF do klienta",
      date_added: date_added2,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body2),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: "Apelacyjna",
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});

    var date_added3 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start3 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal3 = new Date();
    var newFinalDate3 = addDayThre(new Date());
    if (newFinalDate3.getDay() === 0) {
      newFinalDate3 = new Date(
        newFinalDate3.setDate(newFinalDate3.getDate() + 1)
      );
    }
    if (newFinalDate3.getDay() === 6) {
      newFinalDate3 = new Date(
        newFinalDate3.setDate(newFinalDate3.getDate() + 2)
      );
    }

    var date_final = newFinalDate3;

    while (
      checkFree(date_final) ||
      checkHoliday(lawEmp, date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal3 =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body3 = {
      start_date: date_start3,
      final_date: dateFinal3,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Opłata początkowa – sprawdzić czy klient zapłacił wszystkie raty",
      date_added: date_added3,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body3),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    var date_added4 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start4 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var date_final = new Date(taskDate);

    while (
      checkFree(date_final) ||
      //checkHoliday(
      //  props.user.role === "admin" ? responsible : props.user.name,
      //  date_final
      //) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal3 =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body4 = {
      responsible: props.user.role === "admin" ? responsible : lawEmp,
      start_date: date_start4,
      final_date: dateFinal3,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      client_name: hearingData.name,
      task: "Wniosek o uzasadnienie",
      date_added: date_added4,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "SĄDOWE",
      reded: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    if (deliveryWn === "tak") {
      await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body4),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
    }

    var date_added4 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start4 =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();

    var date_final2 = addDayOne(new Date());

    while (
      checkFree(date_final2) ||
      checkHoliday(
        props.user.role === "admin" ? responsible : props.user.name,
        date_final2
      ) ||
      date_final2.getDay() === 0 ||
      date_final2.getDay() === 6
    ) {
      date_final2 = addDayOne(date_final2);
    }

    var dateFinal5 =
      date_final2.getFullYear() +
      "-" +
      (date_final2.getMonth() + 1) +
      "-" +
      date_final2.getDate();

    var body4 = {
      responsible: lawEmp,
      start_date: date_start4,
      final_date: dateFinal5,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      client_name: hearingData.name,
      task: "Poinformować klienta o wyroku",
      date_added: date_added4,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      reded: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    if (deliveryWn === "tak") {
      await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body4),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
    }
  };

  const addNewTask7 = async (rand) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();
    var newFinalDate = addDayWeek(new Date(hearingData.date));
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    var lawEmp = hearingData.lawyer;
    var type = "Apelacyjna";
    if (
      hearingData.court.toLowerCase().includes("apel") ||
      hearingData.subject === "Apelacyjna"
    ) {
      type = "Apelacyjna";
    } else {
      type = "Normalna";
    }
    var index =
      resultSubIndex.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === type && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === type && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === type && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === type && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    var date_final_4 = date_final;

    while (
      checkFree(date_final) ||
      checkHoliday(lawEmp, date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    while (
      checkFree(date_final_4) ||
      //checkHoliday(lawEmp, date_final) ||
      date_final_4.getDay() === 0 ||
      date_final_4.getDay() === 6
    ) {
      date_final_4 = addDayOne(date_final_4);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var dateFinal4 =
      date_final_4.getFullYear() +
      "-" +
      (date_final_4.getMonth() + 1) +
      "-" +
      date_final_4.getDate();

    var body = {
      start_date: date_start,
      final_date: dateFinal4,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Sprawdź wyrok pod względem liczbowym i formalnym, w tym KZP za zabezpieczenie oraz dodaj plik z wyrokiem do dokumentów sprawy",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "SĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
    };

    var body2 = {
      start_date: date_start,
      final_date: dateFinal4,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Uzyskaj od klienta e-mailowo potwierdzenie, że nie składamy wniosku o uzasadnienie i nie składamy apelacji",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "SĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: type,
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body2),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const addNewTask8 = async (rand) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();
    var newFinalDate = addDayTwo(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    var lawEmp = hearingData.lawyer;

    var index =
      resultSubIndex.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    while (
      checkFree(date_final) ||
      checkHoliday(lawEmp, date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var toAdd = [];

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Dodaj do modułu płatności: KZP za I i II instancje i SCF",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: "Apelacyjna",
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});
  };

  const addNewTask9 = async (rand) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();
    var newFinalDate = addDayOne(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    var lawEmp = hearingData.lawyer;

    var index =
      resultSubIndex.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      ).length > 0
        ? +resultSubIndex.filter(
            (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
          )[
            resultSubIndex.filter(
              (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
            ).length - 1
          ].index
        : 0;

    var indexFinal = 0;
    if (
      resultSub.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      ).length > 0
    ) {
      indexFinal =
        resultSub.filter(
          (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
        ).length -
          1 <=
        index + 1
          ? index + 1
          : 0;
      lawEmp = resultSub.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      )[indexFinal].sub;
    }

    while (
      checkFree(date_final) ||
      checkHoliday(lawEmp, date_final) ||
      date_final.getDay() === 0 ||
      date_final.getDay() === 6
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var toAdd = [];

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: hearingData.bank,
      sygn: hearingData.sygn,
      responsible: lawEmp,
      client_name: hearingData.name,
      task: "Telefonicznie poinformuj klienta o wyroku",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: hearingData.court,
      type: "POZASĄDOWE",
      readed: "no",
      clientId: hearingData.clientId.length > 0 ? hearingData.clientId : "",
      task_conn: hearingData.clientId.length > 0 ? "c" : "n",
      team: hearingData.team,
      oriResp: hearingData.lawyer,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        var body2 = {
          user: hearingData.lawyer,
          type: "Apelacyjna",
          index: indexFinal,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertIndexSub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then((data) => {});
      })
      .catch((error) => {});
  };

  const addNoteData = async (e) => {
    if (note) {
      var body = {
        id: props.dateID,
        note: note,
      };

      await fetch("https://apidevkppp.ftpeople.pl/fillNoteDate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      MySwal.fire({
        icon: "succes",
        title: "Dodano",
        text: "notatkę do terminu rozprawy",
      }).then((result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const setStatusWin = async () => {
    var body = {
      status: "wygrana w I instancji",
      status_note: "",
      id: hearingData.clientId,
    };

    fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return;
      })
      .catch((error) => {});
  };

  const setStatusLoose = () => {
    var body = {
      status: "przegrana w I instancji",
      status_note: "",
      id: hearingData.clientId,
    };

    fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const closeAdditionalWezw = (e) => {
    setShowAdditionalWezw(false);
    props.close();
    MySwal.fire({
      icon: "success",
      title: "Dodano",
      text: "wynik rozprawy",
    });
  };

  const setRandApel = () => {
    var rand = getRandomInt(
      resultSub.filter(
        (el) => el.type === "Apelacyjna" && el.user === hearingData.lawyer
      ).length
    );
    addNewTask6(rand);
    addNewTask8(rand);
    addNewTask9(rand);
    addNewTask7(rand);
  };

  const setRandNormal = () => {
    var rand = getRandomInt(
      resultSub.filter(
        (el) => el.type === "Normalna" && el.user === hearingData.lawyer
      ).length
    );
    addNewTask5(rand);
    addNewTask7(rand);
  };

  const addResultData = async (e) => {
    if (result === "Wyrok") {
      if (
        result.length > 0 &&
        result_type.length > 0 &&
        result_note.length > 0
      ) {
        if (deliveryWn === "tak") {
          if (taskDate.length === 0) {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "Wypełnij wymagane pola formularza",
            });
            return;
          }
        }

        var body = {
          id: props.dateID,
          result: result,
          result_type: result_type,
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        if (
          hearingData.court.toLowerCase().includes("apel") ||
          hearingData.subject === "Apelacyjna"
        ) {
          setRandApel();
        } else {
          setRandNormal();
          if (
            result_type === "Wyrok zasądzający w całości" ||
            result_type ===
              "Wyrok zasądzający w całości bez odsetek od dnia wezwania" ||
            result_type === "Wyrok zasądzający w części"
          ) {
            setStatusWin();
          }
          if (result_type === "Wyrok oddalający") {
            setStatusLoose();
          }
        }

        if (
          hearingData.court.toLowerCase().includes("apel") ||
          hearingData.subject === "Apelacyjna"
        ) {
          if (hearingData.clientId !== "") {
            MySwal.fire({
              title: "Czy chcesz zmienić satus sprawy?",
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: "Tak",
              denyButtonText: `Nie`,
            }).then(async (result) => {
              if (result.isConfirmed) {
                setShowAdditionalWezw(true);
              } else if (result.isDenied) {
                props.close();
                MySwal.fire({
                  icon: "success",
                  title: "Dodano",
                  text: "wynik rozprawy",
                });
              }
            });
          }
        } else {
          props.close();
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "wynik rozprawy",
          });
        }

        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odroczenie ogłoszenia wyroku") {
      if (
        result.length > 0 &&
        date.length > 0 &&
        new Date(date).setHours(0, 0, 0, 0) >=
          new Date().setHours(0, 0, 0, 0) &&
        time.length > 0 &&
        subject.length > 0 &&
        result_note.length > 0
      ) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        addNewHearing();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odroczenie z terminem") {
      if (
        result.length > 0 &&
        date.length > 0 &&
        new Date(date) > new Date() &&
        time.length > 0 &&
        result_note.length > 0 &&
        subject.length > 0
      ) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        addNewHearing();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odroczenie bez terminu") {
      if (result.length > 0 && result_note.length > 0) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odroczenie z terminem  + zobowiązanie") {
      if (
        result.length > 0 &&
        date.length > 0 &&
        new Date(date) > new Date() &&
        time.length > 0 &&
        result_note.length > 0 &&
        subject.length > 0 &&
        taskDate.length > 0 &&
        taskType.length > 0
      ) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        addNewHearing();
        //addNewTask("Odpowiedź na zobowiązanie sądu – inne");
        addNewTaskForm();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy oraz zadanie",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odroczenie ogłoszenia wyroku + zobowiązanie") {
      if (
        result.length > 0 &&
        date.length > 0 &&
        new Date(date) > new Date() &&
        time.length > 0 &&
        result_note.length > 0 &&
        subject.length > 0 &&
        taskDate.length > 0 &&
        taskType.length > 0
      ) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        addNewHearing();
        //addNewTask("Odpowiedź na zobowiązanie sądu – inne");
        addNewTaskForm();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy oraz zadanie",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odroczenie bez terminu + zobowiązanie") {
      if (result.length > 0 && taskDate.length > 0 && taskType.length > 0) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        //addNewTask("Odpowiedź na zobowiązanie sądu – inne");
        addNewTaskForm();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy oraz zadanie",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odwołana z nowym terminem") {
      if (
        result.length > 0 &&
        date.length > 0 &&
        new Date(date) > new Date() &&
        time.length > 0 &&
        subject.length > 0
      ) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        addNewHearing();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odwołana bez terminu") {
      if (result.length > 0) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (result === "Odroczono bez terminu - skierowano na niejawne") {
      if (result.length > 0) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        addNewTaskDate(
          "Sprawdzić czy w sprawie wydano już wyrok na posiedzeniu niejawnym"
        );

        addNewTaskForm();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy oraz zadanie",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else if (
      result === "Odroczono bez terminu - skierowano na niejawne + zobowiązanie"
    ) {
      if (result.length > 0) {
        var body = {
          id: props.dateID,
          result: result,
          result_type: "",
          result_note: result_note,
        };

        await fetch("https://apidevkppp.ftpeople.pl/fillResultDate", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        addNewTaskDate(
          "Sprawdzić czy w sprawie wydano już wyrok na posiedzeniu niejawnym"
        );
        addNewTaskForm();
        props.close();
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "wynik rozprawy oraz zadanie",
        });
        return;
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    }
  };

  const checkForCheckHearing = () => {
    var dateNow = new Date();
    var dateHearing = new Date(hearingData.date);

    var difference_In_Time = dateHearing.getTime() - dateNow.getTime();
    var difference_In_Days = difference_In_Time / (1000 * 3600 * 24);

    return true;

    if (dateHearing < dateNow || difference_In_Days > 7) {
      return false;
    } else {
      return true;
    }
  };

  const validateFillHearing = () => {
    if (lawyer === "" && lawyer_form === "") {
      return false;
    }
    return true;
  };

  const copyLink = (e) => {
    navigator.clipboard.writeText(hearingData.online_url);
    MySwal.fire({
      icon: "success",
      title: "Powodzenie",
      text: "Link został skopiowany do schowka",
    });
  };

  const fetchHearingData = async (id) => {
    var body = {
      id: id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setHearingData(data[0]);
        createWeekSet(data[0]);
        setResponsible(data[0].lawyer);
        if (data[0].clientId.length > 0) {
          var body2 = {
            id: data[0].clientId,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data2) => {
              setClient(data2[0]);
              fetchHolidays(data[0]);
            })
            .catch((error) => {});
        } else {
          fetchFreeDays();
        }
      })
      .catch((error) => {});
  };

  const fetchHolidays = async (hearing) => {
    var body = {
      team: hearingData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        fetchSubstituteUserId(hearing);
      })
      .catch((error) => {});
  };

  const fetchSubstituteUserId = async (hearing) => {
    if (hearing.substitute_name !== "" || hearing.guardian_name !== "") {
      var body = {
        name:
          hearing.substitute_name === ""
            ? hearing.guardian_name
            : hearing.substitute_name,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getSubstitutesUserId", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          setSubUserId(
            props.usersData.filter((el) => +el.id === +data[0].userId)[0]
          );
          fetchResultSub();
        })
        .catch((error) => {});
    } else {
      fetchResultSub();
    }
  };

  const fetchResultSub = async (hearing) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getResultSub", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setResultSub(data);
        fetchResultSubIndex();
      })
      .catch((error) => {});
  };

  const fetchResultSubIndex = async (hearing) => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getResultSubIndex", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setResultSubIndex(data);
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        fetchSubstitutes();
      })
      .catch((error) => {});
  };

  const fetchSubstitutes = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSubstitutes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSubstitutes(data);
        setSubstitutesOptions(createSubstitutesOptions(data));
        fetchSubjects();
      })
      .catch((error) => {});
  };

  const fetchSubjects = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHearingSubject", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSubjects(data);
        fetchResults();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setResults(data);
        fetchExpectedResults();
      })
      .catch((error) => {
        fetchExpectedResults();
      });
  };

  const fetchExpectedResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getExpectedResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setExpectedResults(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getData = () => {
    setLoading(true);
    fetchHearingData(props.dateID);
  };

  useEffect(() => {
    getData();
    setTaskTypesOptions(createTaskTypesOptions());
    setLawyersOptions(createLawyersOptions());
  }, []);

  const showNotePopUp = (e) => {
    if (notePopUp) {
      setNotePopUp(false);
      setNoteType("");
    } else {
      setNotePopUp(true);
      setNoteType(e.target.value);
    }
  };

  const showClientPopUp = (e) => {
    setShowClientReport(true);
    setClientsReportValue(hearingData.clientId);
  };

  const closeClientPopUp = (e) => {
    setShowClientReport(false);
    setClientsReportValue("");
  };

  const showEditMode = (e) => {
    if (openEdit) {
      setOpenEdit(false);
      getData();
    } else {
      setOpenEdit(true);
    }
  };

  const deleteHearing = async (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć termin?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteHearingAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteHearingAccept = async () => {
    var body = {
      id: props.dateID,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteDate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Usunięto", "termin rozprawy", "success").then((result) => {
      props.close();
      props.close();
    });
  };

  const showHistory = (e) => {
    if (openHistory) {
      setOpenHistory(false);
    } else {
      setOpenHistory(true);
    }
  };

  const getClientsArray = () => {
    var clients = [];
    var newArray = hearingData.name.split(",");
    newArray.map((el) => {
      clients.push({ id: Math.random() * 100, name: el });
    });

    return clients;
  };

  const createSubstitutesOptions = (data) => {
    var substitutesOptions = [];
    data.map((el) => {
      substitutesOptions.push({ label: el.name, value: el.name });
    });
    return substitutesOptions;
  };

  const createTaskTypesOptions = () => {
    var taskTypesOptions = [];
    props.tasksTypesData.map((el) => {
      taskTypesOptions.push({ label: el.name, value: el.name });
    });
    return taskTypesOptions;
  };

  const createLawyersOptions = () => {
    var taskTypesOptions = [];
    getUsersForTeam().map((el) => {
      taskTypesOptions.push({ label: el.name, value: el.name });
    });
    return taskTypesOptions;
  };

  const getUsersForTeam = (e) => {
    var usersForTeam = [];

    props.usersData.map((el) => {
      usersForTeam.push(el);
    });

    return usersForTeam;
  };

  const getLawyersForTeam = (e) => {
    var usersForTeam = [];

    props.lawyersData.map((el) => {
      if (hearingData.team === 0) {
        usersForTeam.push(el);
      } else if (
        el.team.split(",").filter((el2) => +el2 === +hearingData.team).length >
        0
      ) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const showAddCLientP = () => {
    setShowAddClientConn(true);
  };

  const closeAddCLient = () => {
    setShowAddClientConn(false);
    getData();
  };

  const deleteConn = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz powiązanie?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteConnAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteConnAccept = async () => {
    var body = {
      id: hearingData.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteClientHearing", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Usunięto", "powiązanie", "success").then((result) => {
      getData();
    });
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          final_date >= new Date(el.date_from) &&
          final_date <= new Date(el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const checkSubstitute = () => {
    if (subUserId !== undefined) {
      if (+props.user.id === +subUserId.id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const createHearingButtonWeek = (hearing, date) => {
    var dateH = new Date(hearing.date);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            style={
              hearing.result === "Odwołana z nowym terminem" ||
              hearing.result === "Odwołana bez terminu"
                ? { backgroundColor: "#757573" }
                : hearing.subject === "Ogłoszenie wyroku"
                ? { backgroundColor: "#7db541" }
                : hearing.form === "online"
                ? { backgroundColor: "#e3a74b" }
                : { backgroundColor: "#0b315f" }
            }
            key={hearing.id}
            id="weekLink"
            className="caseLink"
            value={hearing.id}
            onClick={() => {
              return;
            }}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {hearing.name} {getInitials(hearing.lawyer)}
              </div>
              <div className="titleBox_col2">
                {hearing.accepted === "yes" ? (
                  <span id="calendar_check" className="highlight_blue">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.status === "SPRAWDZONO" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.arch === "1" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </button>
        </>
      );
    }
  };

  const calendarWeek = (
    <>
      {hearings.filter((l) => l.lawyer === lawyer).length > 0 ? (
        <>
          <div className="rowCalendar">
            {weekArray.map((el) => (
              <>
                <div key={el} className="colWeekCalendar">
                  <div className="weekContent">
                    <p className="colWeekTitle">
                      {new Date(el).getFullYear()}-
                      {new Date(el).getMonth() + 1 < 10
                        ? "0" + (new Date(el).getMonth() + 1)
                        : new Date(el).getMonth() + 1}
                      -
                      {new Date(el).getDate() < 10
                        ? "0" + new Date(el).getDate()
                        : new Date(el).getDate()}
                    </p>
                    {hearings
                      .filter((l) => l.lawyer === lawyer)
                      .map((el2) => (
                        <>{createHearingButtonWeek(el2, el)}</>
                      ))}
                  </div>
                </div>
              </>
            ))}
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      {openEdit ? (
        <AddDate
          hearingsSheetData={props.hearingsSheetData}
          courtsData={props.courtsData}
          banksData={props.banksData}
          usersData={props.usersData}
          refreshData={props.refreshData}
          user={props.user}
          mode={"edit"}
          close={showEditMode}
          hearingData={hearingData}
          id={props.dateID}
          client={client}
          clients={getClientsArray()}
          checkPermissions={props.checkPermissions}
          lawyers={props.lawyersData}
          substitutes={substitutes}
          results={props.resultsData}
          team={hearingData.team}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
        />
      ) : (
        ""
      )}
      {showAddClientConn ? (
        <AddClientConn
          close={closeAddCLient}
          id={hearingData.id}
          team={hearingData.team}
          place="hearing"
          user={props.user}
        />
      ) : (
        ""
      )}
      {openHistory ? (
        <HistoryPopUp
          clientName={hearingData.name}
          tasksData={props.tasksData}
          hearingsData={props.hearingsData}
          close={showHistory}
          hearingsSheetData={props.hearingsSheetData}
          tasksSheetData={props.tasksSheetData}
          lawyersData={props.lawyersData}
          refreshData={props.refreshData}
          user={props.user}
          courtsData={props.courtsData}
          banksData={props.banksData}
          usersData={props.usersData}
          resultsData={props.resultsData}
          tasksTypesData={props.tasksTypesData}
          checkPermissions={props.checkPermissions}
          team={hearingData.team}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
          tasksTeam2Data={props.tasksTeam2Data}
          tasksTeam2SheetData={props.tasksTeam2SheetData}
          archTasksTeam2={props.archTasksTeam2}
          archDateTeam2={props.archDateTeam2}
          archDate={props.archDate}
          filesData={props.filesData}
          user={props.user}
          logClientAction={props.logClientAction}
          substitutesData={substitutes}
        />
      ) : (
        ""
      )}
      {showClientReport ? (
        <ClientPopUp
          close={closeClientPopUp}
          paymentsData={props.paymentsData}
          paymentsSheetData={props.paymentsSheetData}
          transactionsSheetData={props.transactionsSheetData}
          transactionsASheetData={props.transactionsNaSheetData}
          transactionsData={props.transactionsData}
          paymentsArchiveSheetData={props.paymentsArchiveSheetData}
          id={clientsReportValue}
          team={hearingData.team}
          refreshData={props.refreshData}
          user={props.user.name}
          clientsData={client}
          clientsSheetData={props.clientsSheetData}
          userRole={props.user.role}
          userMail={props.user.mail}
          userPhone={props.user.phone}
          substitutesData={substitutes}
          tasksData={props.tasksData}
          hearingsData={props.hearingsData}
          hearingsSheetData={props.hearingsSheetData}
          tasksSheetData={props.tasksSheetData}
          lawyersData={props.lawyersData}
          courtsData={props.courtsData}
          banksData={props.banksData}
          users={props.usersData}
          resultsData={props.resultsData}
          tasksTypesData={props.tasksTypesData}
          checkPermissions={props.checkPermissions}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
          tasksTeam2Data={props.tasksTeam2Data}
          tasksTeam2SheetData={props.tasksTeam2SheetData}
          archTasksTeam2={props.archTasksTeam2}
          archDateTeam2={props.archDateTeam2}
          archDate={props.archDate}
          clientsSygnSheetData={props.clientsSygnSheetData}
          clientsContactData={props.clientsContactData}
          clientsContactSheetData={props.clientsContactSheetData}
          logClientAction={props.logClientAction}
          clientsLogsData={props.clientsLogsData}
          clientsQuestData={props.clientsQuestData}
          clientsQuestSheetData={props.clientsQuestSheetData}
          tabIndex={0}
          uData={props.user}
          clientsFullData={clients}
          filesData={props.filesData}
        />
      ) : (
        ""
      )}
      {notePopUp ? (
        <NotePopUp
          content={
            noteType === "note" ? hearingData.note : hearingData.result_note
          }
          type={noteType}
          closePopUp={showNotePopUp}
          checkPermissions={props.checkPermissions}
        />
      ) : (
        ""
      )}
      {showAdditionalWezw ? (
        <AdditionalWezw
          clientId={hearingData.clientId}
          close={closeAdditionalWezw}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          place={"hearing"}
        />
      ) : (
        ""
      )}
      {openEdit || openHistory || showClientReport ? (
        ""
      ) : (
        <div className="mainContainerDatePopUp">
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>
              <div className="closeBox">
                <button className="closeClientButton" onClick={props.close}>
                  X
                </button>
              </div>
              <div className="hearingTitle">
                Sprawa klienta{" "}
                <span className="highlight">{hearingData.name}</span> o
                sygnaturze <span className="highlight">{hearingData.sygn}</span>
                {hearingData.accepted === "yes" ? (
                  <>
                    <br />
                    <span className="highlight_green">
                      TERMIN ZOSTAŁ ZAAKCEPTOWANY
                    </span>
                  </>
                ) : (
                  ""
                )}
                {hearingData.status === "SPRAWDZONO" ? (
                  <>
                    <br />
                    <span className="highlight_green">
                      TERMIN ZOSTAŁ SPRAWDZONY
                    </span>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="editButtonBox">
                {(props.checkPermissions("rozprawaEdycja") &&
                  props.user.name === hearingData.lawyer) ||
                (props.checkPermissions("rozprawaEdycja") &&
                  props.user.role === "admin") ? (
                  <button className="acceptButton" onClick={showEditMode}>
                    EDYTUJ
                  </button>
                ) : (
                  ""
                )}
                {props.checkPermissions("rozprawaUsun") &&
                props.user.role === "admin" ? (
                  <button className="acceptButton" onClick={deleteHearing}>
                    Usuń
                  </button>
                ) : (
                  ""
                )}
                {true ? (
                  <>
                    {props.checkPermissions("rozprawaHistoria") ? (
                      <button className="acceptButton" onClick={showHistory}>
                        HISTORIA
                      </button>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              <div style={{ display: "block" }} className="editButtonBox">
                {hearingData.clientId !== "" ||
                hearingData.clientId === undefined ? (
                  <>
                    <div style={{ marginBottom: "15px" }}>
                      <span
                        style={{ color: "black" }}
                        className="highlight_green"
                      >
                        SPRAWA KLIENTA: {client.petitioner}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <button
                        className="acceptButton"
                        onClick={showClientPopUp}
                      >
                        ZOBACZ
                      </button>
                      <button className="acceptButton" onClick={deleteConn}>
                        USUŃ POWIĄZANIE
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ marginBottom: "15px" }}>
                      <span
                        style={{ color: "black" }}
                        className="highlight_green"
                      >
                        ROZPRAWA NIEPOWIĄZANA ZE SPRAWĄ
                      </span>
                    </div>
                    <button
                      style={{ fontSize: "0.7vw" }}
                      className="acceptButton"
                      onClick={showAddCLientP}
                    >
                      DODAJ POWIĄZANIE
                    </button>
                  </>
                )}
              </div>
              <div className="hearingData">
                <div className="hearingBox">
                  <div className="hearingBoxTitle">DATA</div>
                  <div className="hearingBoxContent">
                    {hearingData.date} {hearingData.time}
                  </div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">SĄD</div>
                  <div className="hearingBoxContent">{hearingData.court}</div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">
                    {hearingData.team === 2 ? "PRZECIWNIK PROCESOWY" : "BANK"}
                  </div>
                  <div className="hearingBoxContent">{hearingData.bank}</div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">SYGNATURA</div>
                  <div className="hearingBoxContent">{hearingData.sygn}</div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">WPS</div>
                  <div className="hearingBoxContent">
                    {numberWithCommas(+hearingData.wps)} PLN
                  </div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">FORMA ROZPRAWY</div>
                  <div className="hearingBoxContent">{hearingData.form}</div>
                </div>
                {hearingData.form === "online" ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">LINK DO ROZPRAWY</div>
                    <div className="hearingBoxContent">
                      <div style={{ textAlign: "center", width: "100%" }}>
                        {hearingData.online_url.substring(0, 20)}...
                      </div>

                      <div>
                        {hearingData.online_url.length > 0 ? (
                          <button className="acceptButton" onClick={copyLink}>
                            KOPIUJ LINK
                          </button>
                        ) : (
                          "brak linku"
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="hearingBox">
                  <div className="hearingBoxTitle">PRZEDMIOT ROZPRAWY</div>
                  <div className="hearingBoxContent">{hearingData.subject}</div>
                </div>
                {hearingData.lawyer ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">PRAWNIK</div>
                    <div className="hearingBoxContent">
                      {hearingData.lawyer}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {hearingData.lawyer ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">FORMA REPREZETNACJI</div>
                    <div className="hearingBoxContent">
                      {hearingData.lawyer_form}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {hearingData.lawyer_form === "Substytut" ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">SUBSTYTUT</div>
                    <div className="hearingBoxContent">
                      {hearingData.substitute_name}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {hearingData.lawyer_form === "Opiekun" ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">SUBSTYTUT</div>
                    <div className="hearingBoxContent">
                      {hearingData.guardian_name}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {hearingData.result ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">WYNIK ROZPRAWY</div>
                    <div className="hearingBoxContent">
                      {hearingData.result}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {hearingData.result_type ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">TYP WYROKU</div>
                    <div className="hearingBoxContent">
                      {hearingData.result_type}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {hearingData.result_note ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">
                      {hearingData.result === "Wyrok"
                        ? "NOTATKA DO WYROKU"
                        : "NOTATKA DO TERMINU"}
                    </div>
                    <div className="hearingBoxContent">
                      <div className="noteShort">
                        {hearingData.result_note.substring(0, 100)}...
                      </div>

                      <button
                        id="boxButton"
                        className="acceptButton"
                        value="result_note"
                        onClick={showNotePopUp}
                      >
                        POKAŻ CAŁĄ TREŚĆ
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {hearingData.note ? (
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">UWAGI</div>
                    <div className="hearingBoxContent">
                      <div
                        className="noteShort"
                        style={{ lineBreak: "anywhere" }}
                      >
                        {hearingData.note.substring(0, 100)}...
                      </div>
                      <button
                        id="boxButton"
                        className="acceptButton"
                        value="note"
                        onClick={showNotePopUp}
                      >
                        POKAŻ CAŁĄ TREŚĆ
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="hearingFunctionalitesBox">
                {props.checkPermissions("rozprawaAkceptacja") ? (
                  hearingData.accepted === "no" ? (
                    <button
                      className="functionalitesButton"
                      value="fillHearing"
                      onClick={acceptHearing}
                    >
                      ZAAKCEPTUJ TERMIN
                    </button>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {props.checkPermissions("rozprawaPrawnik") &&
                props.user.role === "admin" ? (
                  hearingData.accepted === "yes" &&
                  (hearingData.lawyer === "" ||
                    hearingData.lawyer === undefined) ? (
                    <button
                      className="functionalitesButton"
                      value="fillHearing"
                      onClick={setFill}
                    >
                      PRZYPISZ PRAWNIKA
                    </button>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {checkSubstitute() ||
                (props.checkPermissions("rozprawaWynik") &&
                  (hearingData.lawyer === props.user.name ||
                    props.user.role === "admin")) ? (
                  hearingData.accepted === "yes" &&
                  (hearingData.result === "" ||
                    hearingData.result === undefined) ? (
                    <button
                      className="functionalitesButton"
                      value="fillResult"
                      onClick={setFill}
                    >
                      UZUPEŁNIJ WYNIK ROZPRAWY
                    </button>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {props.checkPermissions("rozprawaUwagi") &&
                (hearingData.lawyer === props.user.name ||
                  props.user.role === "admin") ? (
                  hearingData.accepted === "yes" &&
                  (hearingData.note === "" ||
                    hearingData.note === undefined) ? (
                    <button
                      className="functionalitesButton"
                      value="fillNote"
                      onClick={setFill}
                    >
                      DODAJ UWAGI
                    </button>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {props.checkPermissions("rozprawaSprawdzenie") ? (
                  hearingData.accepted === "yes" &&
                  checkForCheckHearing() &&
                  hearingData.status === "DO SPRAWDZENIA" ? (
                    <button
                      id="buttonCheck"
                      className="functionalitesButton"
                      value="fillNote"
                      onClick={changeStausChecked}
                    >
                      OZNACZ JAKO SPRAWDZONY
                    </button>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
              {fillHearing ? (
                <>
                  <div className="inputContainer">
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Prawnik odpowiedzialny{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={lawyer}
                          onChange={handleLawyerChange}
                        >
                          {lawyer === "" ? (
                            <option key="0" value="no">
                              Wybierz z listy...
                            </option>
                          ) : (
                            ""
                          )}
                          {getLawyersForTeam().map((el) => (
                            <option key={el.name} value={el.name}>
                              {el.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="inputCol_3">
                        <label>
                          Forma reprezentacji{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={lawyer_form}
                          onChange={handleLawyerFormChange}
                        >
                          {lawyer_form === "" ? (
                            <option key="0" value="no">
                              Wybierz z listy...
                            </option>
                          ) : (
                            ""
                          )}
                          <option key={"0b"} value="Osobiście">
                            Osobiście
                          </option>
                          <option key={"1b"} value="Substytut">
                            Substytut
                          </option>
                          <option key={"2b"} value="Opiekun">
                            Opiekun
                          </option>
                        </select>
                      </div>
                      {lawyer_form === "Substytut" ? (
                        <>
                          <div className="inputCol_3">
                            <label>Imię i nazwisko substytuta</label>
                            <Select
                              noOptionsMessage={() => "Brak danych"}
                              placeholder={"Wybierz..."}
                              isClearable={false}
                              options={substitutesOptions}
                              onChange={handleSubstituteNameChange}
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {lawyer_form === "Opiekun" ? (
                        <>
                          <div className="inputCol_3">
                            <label>Imię i nazwisko substytuta</label>
                            <Select
                              noOptionsMessage={() => "Brak danych"}
                              placeholder={"Wybierz..."}
                              isClearable={false}
                              options={substitutesOptions}
                              onChange={handleGuardianNameChange}
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="acceptButtonContainerDate">
                      <button className="acceptButton" onClick={addHearingData}>
                        ZAPISZ DANE
                      </button>
                    </div>
                  </div>
                  <div>
                    {lawyer ? (
                      <>
                        <p>
                          ROZPRAWY PRAWNIKA W TYGODNIU (
                          {hearings.filter((l) => l.lawyer === lawyer).length})
                        </p>
                        {calendarWeek}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                ""
              )}
              {fillResult ? (
                <>
                  <div className="inputContainer">
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Wynik rozprawy <span className="requiredStar">*</span>
                        </label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={result}
                          onChange={handleResultChange}
                        >
                          {result === "" ? (
                            <option key="0" value="no">
                              Wybierz z listy...
                            </option>
                          ) : (
                            ""
                          )}
                          {expectedResults.map((r) => (
                            <option key={r.name} value={r.name}>
                              {r.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {result === "Wyrok" ? (
                        <>
                          <div className="inputCol_3">
                            <label>
                              Rodzaj wyroku{" "}
                              <span className="requiredStar">*</span>
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={result_type}
                              onChange={handleResultTypeChange}
                            >
                              {result_type === "" ? (
                                <option key="0" value="no">
                                  Wybierz z listy...
                                </option>
                              ) : (
                                ""
                              )}
                              {results.map((el) => (
                                <option key={el.name} value={el.name}>
                                  {el.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="inputCol_3">
                            <label>
                              Wniosek o doręczenie z uzas.{" "}
                              <span className="requiredStar">*</span>
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={deliveryWn}
                              onChange={handleDeliveryWnChange}
                            >
                              <option key={0} value="nie">
                                NIE
                              </option>
                              <option key={1} value="tak">
                                TAK
                              </option>
                            </select>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    {deliveryWn === "tak" ? (
                      <div className="inputBox">
                        <div className="inputCol_3">
                          <label>
                            Data zakończenia zadania{" "}
                            <span className="requiredStar">*</span>
                          </label>
                          <input
                            type="date"
                            id="date"
                            name="date"
                            value={taskDate}
                            onChange={handleTaskDateChange}
                            min="2002-01-01"
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {result === "Odroczenie z terminem  + zobowiązanie" ||
                    result === "Odroczenie ogłoszenia wyroku + zobowiązanie" ||
                    result === "Odroczenie z terminem" ||
                    result === "Odroczenie ogłoszenia wyroku" ||
                    result === "Odwołana z nowym terminem" ? (
                      <>
                        <div className="inputBox">
                          <div className="inputCol_3">
                            <label>
                              Data kolejnej rozprawy{" "}
                              <span className="requiredStar">*</span>
                            </label>
                            <input
                              type="date"
                              id="date"
                              name="date"
                              value={date}
                              onChange={handleDateChange}
                              min="2002-01-01"
                            />
                          </div>
                          <div className="inputCol_3">
                            <label>
                              Godzina kolejnej rozprawy{" "}
                              <span className="requiredStar">*</span>
                            </label>
                            <input
                              type="time"
                              id="date"
                              name="date"
                              value={time}
                              onChange={handleTimeChange}
                              min="2002-01-01"
                            />
                          </div>
                          <div className="inputCol_3">
                            <label>
                              Temat kolejnej rozprawy{" "}
                              <span className="requiredStar">*</span>
                            </label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={subject}
                              onChange={handleSubjectChange}
                            >
                              {subject === "" ? (
                                <option key="0" value="no">
                                  Wybierz z listy...
                                </option>
                              ) : (
                                ""
                              )}
                              {subjects
                                ? subjects.map((e) => (
                                    <>
                                      <option key={e.id} value={e.name}>
                                        {e.name}
                                      </option>
                                    </>
                                  ))
                                : ""}
                            </select>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {result === "Odroczenie z terminem  + zobowiązanie" ||
                    result === "Odroczenie ogłoszenia wyroku + zobowiązanie" ||
                    result === "Odroczenie bez terminu + zobowiązanie" ||
                    result ===
                      "Odroczono bez terminu - skierowano na niejawne + zobowiązanie" ? (
                      <>
                        <div className="inputBox">
                          <div className="inputCol_3">
                            <label>
                              Data zakończenia zadania{" "}
                              <span className="requiredStar">*</span>
                            </label>
                            <input
                              type="date"
                              id="date"
                              name="date"
                              value={taskDate}
                              onChange={handleTaskDateChange}
                              min="2002-01-01"
                            />
                          </div>
                          <div className="inputCol_3">
                            <label>
                              Zadanie <span className="requiredStar">*</span>
                            </label>
                            <Select
                              noOptionsMessage={() => "Brak danych"}
                              placeholder={"Wybierz..."}
                              isClearable={false}
                              options={taskTypesOptions}
                              onChange={handleTaskTypeChange}
                            />
                          </div>
                          {props.user.role === "admin" ? (
                            <div className="inputCol_3">
                              <label>
                                Osoba odpowiedzialna{" "}
                                <span className="requiredStar">*</span>
                              </label>
                              <Select
                                noOptionsMessage={() => "Brak danych"}
                                placeholder={"Wybierz..."}
                                isClearable={false}
                                options={lawyersOptions}
                                onChange={handleResponsibleChange}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {result === "Wyrok" ||
                    result === "Odroczenie z terminem" ||
                    result === "Odroczenie bez terminu" ||
                    result === "Odroczenie z terminem  + zobowiązanie" ||
                    result === "Odroczenie ogłoszenia wyroku + zobowiązanie" ||
                    result === "Odroczenie bez terminu + zobowiązanie" ||
                    result === "Odroczenie ogłoszenia wyroku" ||
                    result ===
                      "Odroczono bez terminu - skierowano na niejawne" ||
                    result ===
                      "Odroczono bez terminu - skierowano na niejawne + zobowiązanie" ? (
                      <>
                        <div className="inputBox">
                          <div className="inputCol_1">
                            <label>
                              {result === "Wyrok"
                                ? "Notatka do wyroku"
                                : "Notatka do terminu"}{" "}
                              <span className="requiredStar">*</span>
                            </label>
                            <textarea
                              spellcheck="false"
                              className="textAreaNote"
                              type="text"
                              id="url"
                              name="url"
                              value={result_note}
                              onChange={handleResultNoteChange}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className="acceptButtonContainerDate">
                      <button className="acceptButton" onClick={addResultData}>
                        ZAPISZ DANE
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              {fillNote ? (
                <>
                  <div className="inputContainer">
                    <div className="inputBox">
                      <div className="inputCol_1">
                        <label>Uwagi</label>
                        <textarea
                          spellcheck="false"
                          className="textAreaNote"
                          type="text"
                          id="url"
                          name="url"
                          value={note}
                          onChange={handleNoteChange}
                        />
                      </div>
                    </div>
                    <div className="acceptButtonContainerDate">
                      <button className="acceptButton" onClick={addNoteData}>
                        ZAPISZ DANE
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default DatePopUp;
